import React, { useEffect } from "react";

// Lightweight, dependency-free confetti burst. Auto-dismisses.
export default function Confetti({ pieces = 44, onDone }) {
  useEffect(() => {
    const t = setTimeout(() => onDone && onDone(), 2800);
    return () => clearTimeout(t);
  }, [onDone]);

  const colors = ["#E63946", "#F4A261", "#2A9D8F", "#E9C46A", "#457B9D", "#F72585"];
  const items = Array.from({ length: pieces }).map((_, i) => ({
    left: Math.random() * 100,
    delay: Math.random() * 0.5,
    dur: 1.9 + Math.random() * 1.3,
    color: colors[i % colors.length],
    rot: Math.random() * 360,
    w: 6 + Math.random() * 6,
  }));

  return (
    <div className="fixed inset-0 z-[3000] pointer-events-none overflow-hidden" data-testid="confetti">
      <style>{`@keyframes kn-conf-fall{0%{transform:translateY(-12vh) rotate(0);opacity:1}100%{transform:translateY(112vh) rotate(720deg);opacity:.85}}`}</style>
      {items.map((p, i) => (
        <span key={i} style={{
          position: "absolute", top: 0, left: `${p.left}%`, width: p.w, height: p.w * 0.42,
          background: p.color, borderRadius: 2, transform: `rotate(${p.rot}deg)`,
          animation: `kn-conf-fall ${p.dur}s ${p.delay}s cubic-bezier(.4,.6,.5,1) forwards`,
        }} />
      ))}
    </div>
  );
}
